import { render, staticRenderFns } from "./ProductHot.vue?vue&type=template&id=1d6670e4&"
import script from "./ProductHot.vue?vue&type=script&lang=js&"
export * from "./ProductHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports